import { Component } from '@angular/core';
import { BrokerPortalFeatureCodes } from '@brokerportal/common/enums';
import { FeatureFlagService, SalesIqService } from '@brokerportal/common/services';
import { CustomBroadcastChannel } from '@brokerportal/common/services/custom-broadcast-channel';
import { GLOBAL_CONSTANTS } from 'app/constants';

@Component({
    selector: 'bp-toolbar-user-button',
    templateUrl: './toolbar-user-button.component.html',
    styleUrls: ['./toolbar-user-button.component.scss']
})
export class ToolbarUserButtonComponent {
    isOpen: boolean;
    displayName: string;

    constructor(
        private bc: CustomBroadcastChannel,
        private featureFlagService: FeatureFlagService,
        private salesIqService: SalesIqService
    ) {}

    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }

    onClickOutside() {
        this.isOpen = false;
    }

    handleLogout() {
        this.salesIqService.resetOnLogout();
        this.bc.postMessage(GLOBAL_CONSTANTS.CHANNEL.USER.LOGOUT);
    }
}
